import { formatText, formatVal, valToPercent } from '../../../../helpers/value'

export const DATA_TABLE = {
  businessSize: {
    key: 'businessSize',
    title: 'industryOverview.businessSize.BUSINESS_SIZE',
    thStyle: {},
    format: (val) => formatText(val),
  },
  numberCompanies: {
    key: 'numberCompanies',
    title: 'industryOverview.businessSize.NUMBER_OF_COMPANIES',
    thStyle: {
      justifyContent: 'flex-end',
    },
    format: (val, locale) => formatVal(val, locale, false, 0),
  },
  totalPercentCompanies: {
    key: 'totalPercentCompanies',
    title: 'industryOverview.businessSize.TOTAL_COMPANIES_PERCENT',
    thStyle: {
      justifyContent: 'flex-end',
    },
    format: (val, locale) => valToPercent(val, locale),
  },
}
